import {Badge} from 'react-bootstrap'

const COLORS = {
  ACTIVE: 'success',
  INACTIVE: 'warning',
}

export const BadgeStatus = ({state}: {state: string}) => {
  return <Badge bg={COLORS[state]}>{state}</Badge>
}
